import * as React from "react";
const SvgFire = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M16.994 14.839a.75.75 0 0 0-1.489-.185c-.194 1.565-1.82 2.844-3.505 2.844a.75.75 0 0 0 0 1.5c2.308 0 4.69-1.717 4.994-4.16Z"
      fill="currentColor"
    />
    <path
      d="M13.74 2.873a.75.75 0 0 0-1.364-.539c-.04.06-.102.145-.181.252-.296.404-.816 1.115-1.187 1.91-.481 1.03-.816 2.394-.199 3.796a4.6 4.6 0 0 0 .33.636l.065.108c.09.148.167.277.242.421.167.326.304.709.304 1.293 0 .296-.141.695-.428 1.02-.276.314-.644.512-1.072.512-.544 0-.985-.156-1.277-.402-.276-.232-.473-.588-.473-1.13 0-.981.193-1.459.67-2.415a.75.75 0 0 0-.907-1.046c-.955.318-2.012 1.203-2.819 2.38C4.622 10.869 4 12.452 4 14.25 4 18.698 7.616 22 12 22s8-3.302 8-7.75c0-2.018-1.012-3.568-2.047-4.67a14.376 14.376 0 0 0-1.503-1.364c-.16-.129-.3-.238-.419-.331a6.466 6.466 0 0 1-.5-.415c-1.597-1.597-1.997-3.36-1.791-4.597Zm-1.555 4.822c-.375-.843-.21-1.724.182-2.565l.032-.068c.31 1.164.974 2.372 2.07 3.468.167.167.444.384.732.61l.31.246c.423.339.9.743 1.349 1.221.902.961 1.64 2.16 1.64 3.643 0 3.552-2.876 6.25-6.5 6.25s-6.5-2.698-6.5-6.25c0-1.45.503-2.743 1.181-3.732.115-.167.233-.324.352-.469A6.89 6.89 0 0 0 7 10.75c0 .958.373 1.743 1.007 2.277.618.52 1.426.755 2.243.755.932 0 1.69-.443 2.198-1.02.498-.566.802-1.308.802-2.012 0-.862-.213-1.479-.47-1.98-.1-.193-.21-.374-.3-.524l-.054-.089a3.14 3.14 0 0 1-.24-.462Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgFire;
